/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/utils'], function(backbone, utils) {
    return backbone.Model.extend({
        defaults: {
            /** @var {SkuModel} sku */
            sku: null,
            enabled: true,
            selected: false,
            price: null,
            salePrice: null,
            vatRate: null
        },

        /**
         * @param {boolean} withVat
         * @returns {number}
         */
        getPrice: function(withVat) {
            return withVat ? utils.applyVat(this.get('price'), this.get('vatRate')) : this.get('price');
        },

        /**
         * @param {boolean} withVat
         * @returns {number}
         */
        getSalePrice: function(withVat) {
            return withVat ? utils.applyVat(this.get('salePrice'), this.get('vatRate')) : this.get('salePrice');
        },

        /**
         * @param {boolean} withVat
         * @param {string} [pricingSetName]
         * @return {number}
         */
        getSkuPrice: function(withVat, pricingSetName) {
            const price = this.get('sku').getPrice(pricingSetName);

            return withVat ? utils.applyVat(price, this.get('vatRate')) : price;
        },

        /**
         * @param {boolean} withVat
         * @param {string} [pricingSetName]
         * @return {number}
         */
        getSkuRetailPrice: function(withVat, pricingSetName) {
            const price = this.get('sku').get('retailCost');

            return withVat ? utils.applyVat(price, this.get('vatRate')) : price;
        }
    });
});
